import $ from 'jquery';

const backToTopInit = () => {
    const $component = $('.c-back-to-top');
    const scrollSpeed = 'slow';

    if ($component.length) {
        // scroll to top
        $component.click(e => {
            e.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, scrollSpeed);
        });
    }
};

// doc ready
$(() => {
    backToTopInit();
});



// WEBPACK FOOTER //
// ./src/components/back-to-top/c-back-to-top.js